import { ChatHistoryMessage } from '@choco-admin/types';
import { Card, CardBody, Chip } from '@heroui/react';
import React from 'react';
import { FiMessageSquare, FiPackage } from 'react-icons/fi';

interface ChatHistoryListProps {
  messages: ChatHistoryMessage[];
}

export const ChatHistoryList: React.FC<ChatHistoryListProps> = ({
  messages,
}) => {
  const formatDateTime = (dateTime: string) => {
    return new Date(dateTime).toLocaleString();
  };

  return (
    <div className="space-y-4">
      {messages.map((message) => (
        <Card key={message.id} className="shadow-sm">
          <CardBody>
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                {message.orderId ? (
                  <FiPackage className="w-4 h-4 text-primary" />
                ) : (
                  <FiMessageSquare className="w-4 h-4 text-secondary" />
                )}
                <span className="font-medium text-foreground">
                  {message.from}
                </span>
                <span className="text-foreground-500">→</span>
                <span className="text-foreground-600">{message.to}</span>
              </div>

              <div className="flex items-center gap-2">
                {message.orderId && (
                  <Chip size="sm" variant="flat" color="primary">
                    Order #{message.orderId}
                  </Chip>
                )}
                <span className="text-sm text-foreground-500">
                  {formatDateTime(message.dateTime)}
                </span>
              </div>
            </div>

            <div className="text-foreground-700">{message.message}</div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
};
